import styled from "styled-components";

export const Wrapper = styled.div`
  width: 80%;
  display: grid;
  grid-template-columns: 30% 30% 30%;
  justify-content: space-between;
`;
